module.exports = __webpack_public_path__ + "img/abgc9.252e377c.jpg";